// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { NavigateBackButton } from "../../common/NavigateBackButton";
import { NEWSLETTER_VIEW_CLASS_NAME } from "../../../../core/constants/className";
import { CardList } from "../../common/card/CardList";
import { SEODiv } from "../../common/seo/SEODiv";
import { ArticleHeader } from "../../common/title/ArticleHeader";
import { ProductModel } from "../../../../../../io/hyperify/core/store/types/product/ProductModel";
import {
    T_NEWSLETTER_ROUTE_DESCRIPTION,
    T_NEWSLETTER_ROUTE_TITLE,
    T_READ_ALL_NEWSLETTER,
    T_SITE_NAME,
} from "../../../../core/constants/translation";
import {
    NEWSLETTERS_ROUTE,
} from "../../../../core/constants/route";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import "./NewsLetterView.scss";

export interface NewsLetterViewProps {
    readonly t?: TranslationFunction;
    readonly className?: string;
    readonly button?: string;
}

export function NewsLetterView (props: NewsLetterViewProps) {

    const t: TranslationFunction = props?.t ?? ((key: string): string => key);
    const className = props?.className;

    const productList: ProductModel[] = [];

    return (
        <SEODiv className={"newsletter-view"}
             path={NEWSLETTERS_ROUTE}
             title={t(T_NEWSLETTER_ROUTE_TITLE)}
             description={t(T_NEWSLETTER_ROUTE_DESCRIPTION)}
             siteName={t(T_SITE_NAME)}
        >
            <article
                className={
                    NEWSLETTER_VIEW_CLASS_NAME + (className ? ` ${className}` : "")
                }
            >
                <ArticleHeader
                    title={t("newsletter.title")}
                    className="view"
                    t={t}
                />

                <div className={`${NEWSLETTER_VIEW_CLASS_NAME}-content`}>
                    <CardList
                        productList={productList}
                        buttonLabel={`${T_READ_ALL_NEWSLETTER}`}
                        className={`${NEWSLETTER_VIEW_CLASS_NAME}-white`}
                        t={t}
                    />
                </div>
                <div className={`${NEWSLETTER_VIEW_CLASS_NAME}-upload`}>
                    <NavigateBackButton
                        className={`${NEWSLETTER_VIEW_CLASS_NAME}-blue`}
                        children={t("upload.more")}
                    />
                </div>
            </article>
        </SEODiv>
    );
}
